<template>
  <div class="kit-version-toggle">
    <label
      class="toggle-option"
      :class="{ active: activeVersion === 'v1' }"
      @click="goTo('v1')"
    >
      <span class="toggle-text">Air Kit</span>
    </label>
    <label
      class="toggle-option"
      :class="{ active: activeVersion === 'v2' }"
      @click="goTo('v2')"
    >
      <span class="toggle-text">Dust Kit</span>
    </label>
  </div>
</template>

<script>
export default {
  name: "KitVersionToggle",
  props: {
    activeVersion: {
      type: String,
      required: true,
      validator: v => ["v1", "v2"].includes(v)
    }
  },
  methods: {
    goTo(version) {
      if (version === this.activeVersion) return;
      const route = version === "v2" ? "/dashboard-v2" : "/dashboard";
      this.$router.push(route);
    }
  }
};
</script>

<style scoped>
.kit-version-toggle {
  display: flex;
  gap: 0;
  margin: 0 0 15px 0;
}
.toggle-option {
  padding: 10px 30px;
  border: none;
  outline: none;
  cursor: pointer;
  font-family: TTNormsMedium, sans-serif;
  font-size: 15px;
  background-color: #fff;
  color: #58595b;
  border-bottom: 3px solid transparent;
  transition: all 0.2s ease;
  border-radius: 5px 5px 0 0;
  user-select: none;
}
.toggle-option:hover {
  background-color: #e0e9f4;
}
.toggle-option.active {
  color: #005eb8;
  border-bottom-color: #005eb8;
  background-color: #fff;
  font-weight: bold;
  cursor: default;
}
.toggle-text {
  pointer-events: none;
}
@media print {
  .kit-version-toggle {
    display: none;
  }
}
</style>
